import { apiv1 } from "@/request/apiv1";
import qs from "qs";

export function GetCaseList(params = { page: 0, size: 20 }) {
  return new Promise((resolve, reject) => {
    apiv1
      .get(
        `/engineering/cases?${qs.stringify(params, {
          arrayFormat: "repeat",
        })}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 206) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function GetCaseById(id = null) {
  return new Promise((resolve, reject) => {
    apiv1
      .get(`/engineering/cases/${id}`)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function PostCases(params = []) {
  return new Promise((resolve, reject) => {
    apiv1
      .post(`/engineering/cases`, params)
      .then((res) => {
        if (res.status === 201) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function PutCases( params = []) {
  return new Promise((resolve, reject) => {
    apiv1
      .put(`/engineering/cases`, params)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 启用\禁用
 * @param {String,Number} id
 * @param {Boolean} bool
 */
export function ToggleDisableById(ids = [], bool = null) {
  return new Promise((resolve, reject) => {
    apiv1
      .put(`/engineering/cases/disable?ids=${ids}&is_true=${bool}`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 获取启用或者禁用许可
 * @param {Number[]} ids
 */
export function GetDiasbleCheck(ids = []) {
  return new Promise((resolve, reject) => {
    apiv1
      .get(`/engineering/cases/can/disable?ids=${ids}`)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 获取修改许可
 * @param {Number[]} ids
 */
export function GetUpdateCheck(ids = []) {
  return new Promise((resolve, reject) => {
    apiv1
      .get(`/engineering/cases/can/update?ids=${ids}`)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
